var map = {
	"./1.png": 82525,
	"./10.png": 24585,
	"./11.png": 30112,
	"./2.png": 1318,
	"./3.png": 66511,
	"./4.png": 97488,
	"./5.png": 3737,
	"./6.png": 20802,
	"./7.png": 11307,
	"./8.png": 89916,
	"./9.png": 42181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98381;